export default {
  signals: { partial: 'Some linked signals belong to features of another plan; the links to the available ones are shown here.' },
};
